//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('custGrpLangs', {
//        templateUrl: 'views/components/views/custGrpLangs/custGrpLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'custGrpLangsService', function ($stateParams, stateService, translateService, modalService, custGrpLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let custGrpId = $stateParams.custgrp_id;

//            let translations = {
//                confirmation: '',
//                ok: ''
//            };

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION

//            async function loadLanguages() {
//                vm.model.inputListLanguages = (await custGrpLangsService.listCustomerGroupLanguages({ custgrp_id: custGrpId }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                custGrpLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function (response) {
//                    if (response[0].ws_result === '1') {
//                    	modalService.show({
//                    		type: 'success',
//                    		title: translations.confirmation,
//                            message: response[0].ws_result_message,
//                    		buttons: [{
//                    			label: translations.ok,
//                                cssClass: 'btn-success',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    stateService.back();
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ANGULAR ON INIT

//            vm.$onInit = function () {
//                translate();
//                loadLanguages();
//            };

//            // #endregion ANGULAR ON INIT

//        }]
//    });
//})();
